import { Branch } from '../base/branch';
import { Endpoint } from './endpoint';

export class Realm extends Branch {
    static _type: string = 'Realm';

    override load(source?: any): void {
        this.copy(source);

        if (source) {
            const { nodes, branches } = source;

            nodes?.forEach((node: any) => {
                this.nodes.push(new Endpoint(node));
            });

            branches?.forEach((branch: any) => {
                this.branches.push(new Realm(branch));
            });
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Realm;
    }
}
